import { Capacitor } from '@capacitor/core';

export const CompassService = {
  isNative() {
    try { return Capacitor?.isNativePlatform?.() === true; } catch { return false; }
  },
  async addListener(callback) {
    // For web deployments, rely on browser DeviceOrientation API (handled in UnifiedMap.jsx)
    if (!this.isNative()) return { remove: () => {} };
    
    try {
      // Dynamically import Motion only on native platforms to avoid webpack errors on web
      const { Motion } = await import('@capacitor/motion');
      
      // Request permission for device motion (required on iOS and some Android devices)
      if (typeof DeviceMotionEvent !== 'undefined' && DeviceMotionEvent.requestPermission) {
        try {
          const permission = await DeviceMotionEvent.requestPermission();
          if (permission !== 'granted') {
            console.warn('📍 Device motion permission denied, falling back to web API');
            return { remove: () => {} };
          }
        } catch (error) {
          console.warn('📍 Error requesting device motion permission:', error);
          return { remove: () => {} };
        }
      }

      // Add listener for orientation changes (compass heading)
      const listener = await Motion.addListener('orientation', (event) => {
        // event is RotationRate with alpha (compass heading), beta, gamma
        // alpha: rotation around Z axis (0-360 degrees, where 0° = North)
        const alpha = event.alpha;
        
        if (alpha !== null && alpha !== undefined && typeof alpha === 'number' && isFinite(alpha)) {
          // Normalize to 0-360 range
          const normalized = ((alpha % 360) + 360) % 360;
          callback(normalized);
        }
      });

      console.log('📍 Native compass listener attached via @capacitor/motion');
      return listener;
    } catch (error) {
      console.error('📍 Error setting up native compass:', error);
      // Fall back to web API
      return { remove: () => {} };
    }
  }
};

export default CompassService;

